import Vue from 'vue';
import Photographer from "../../components/Photographer";

let els;

if ((els = document.querySelectorAll('.animated-container')).length > 0) {
	for (let i = 0; i < els.length; i++) {
		const el = els[i];

		new Vue({
			el,
			name: 'Photographer',
			components: {Photographer}
		});
	}
}
